<template>
  <div class="content">
    <div class="top">
      <div class="elec_speed">
        <el-steps :active="1" finish-status="success" simple>
          <el-step :title=selectedSeries></el-step>
          <el-step :title=loadCondition></el-step>
          <el-step :title=reducerSize></el-step>
          <el-step :title=selectMotor></el-step>
          <el-step :title=complete></el-step>
        </el-steps>
      </div>
    </div>
    <div class="elec_select">
      <el-row>
        <el-col :span="24">
          <div class="grid-content bg-purple elec_select_left">
            <img :src=picUrl alt="">
            <div class="text">{{$t('message.reducer')}} <span>{{ reducerName }}</span></div>
          </div>
        </el-col>
      </el-row>
    </div>
    <!-- 减速机系列详情表 -->
    <div class="elec_detail">
      <el-row>
        <el-col :span="24">
          <h3>{{$t('message.info01')}}</h3>
          <div class="cascader_box">
            <span style="padding-right:10px;">{{$t('message.ratio')}}</span>
            <el-cascader filterable
              :options="options"
              :show-all-levels="false"
              v-model="selectedOptions"
              :props="optionProps"
              @change="handleChange"
            >
            </el-cascader>
          </div>
        </el-col>
        <el-col :span="24">
          <h3>{{$t('message.info02')}}</h3>
          <div class="slider_box">
            <el-slider
              v-model="value"
              :step="1"
              :max="18"
              :min="4"
              @change="sliderChange"
              show-input>
            </el-slider>
          </div>
        </el-col>
        <el-col :span="24">
          <h3>{{$t('message.info03')}}</h3>
          <el-col :span="24" class="paramBox">
            <el-col :span="8">
              <el-form :model="dynamicValidateForm" ref="dynamicValidateForm" label-width="100px" class="dynamic">
                <span class="dynamic_text">{{$t('message.title01')}}</span>
                <el-form-item
                  v-for="(domain, index) in dynamicValidateForm.domains"
                  :label="'T'  + (index+1)"
                  :key="domain.key"
                  :prop="'domains.' + index + '.value'"
                  :rules="[{
                    required: true, message: '此项不能为空', trigger: 'blur'
                  }]">
                  <el-input oninput="value=value.replace(/[^\d.]/g,'')" v-model="domain.value" auto-complete="off"></el-input>
                </el-form-item>
              </el-form>
            </el-col>
            <el-col :span="8">
              <el-form :model="dynamicValidateForm_2" ref="dynamicValidateForm_2" label-width="100px" class="dynamic">
                <span class="dynamic_text">{{$t('message.title02')}}</span>
                <el-form-item
                  v-for="(domain, index) in dynamicValidateForm_2.domains"
                  :label="'n' + (index+1)"
                  :key="domain.key"
                  :prop="'domains.' + index + '.value'"
                  :rules="[{
                    required: true, message: '此项不能为空', trigger: 'blur'
                  }]">
                  <el-input oninput="value=value.replace(/[^\d.]/g,'')" v-model="domain.value" auto-complete="off"></el-input>
                </el-form-item>
              </el-form>
            </el-col>
            <el-col :span="8">
              <el-form :model="dynamicValidateForm_3" ref="dynamicValidateForm_3" label-width="100px" class="dynamic">
                <span class="dynamic_text">{{$t('message.title03')}}</span>
                <el-form-item
                  v-for="(domain, index) in dynamicValidateForm_3.domains"
                  :label="'t' + (index+1)"
                  :key="domain.key"
                  :prop="'domains.' + index + '.value'"
                  :rules="[{
                    required: true, message: '此项不能为空', trigger: 'blur'
                  }]">
                  <el-input oninput="value=value.replace(/[^\d.]/g,'')" v-model="domain.value" auto-complete="off"></el-input>
                </el-form-item>
              </el-form>
            </el-col>
            <el-col :span="8">
              <el-form :model="dynamicValidateForm_4" ref="dynamicValidateForm_4" label-width="100px" class="dynamic">
                <span class="dynamic_text">{{$t('message.title04')}} </span>
                <el-form-item
                  v-for="(domain, index) in dynamicValidateForm_4.domains"
                  :label="'Fr' + (index+1)"
                  :key="domain.key"
                  :prop="'domains.' + index + '.value'"
                  :rules="[{
                    required: true, message: '此项不能为空', trigger: 'blur'
                  }]">
                  <el-input oninput="value=value.replace(/[^\d.]/g,'')" v-model="domain.value" auto-complete="off"></el-input>
                </el-form-item>
              </el-form>
            </el-col>
            <el-col :span="8">
              <el-form :model="dynamicValidateForm_5" ref="dynamicValidateForm_5" label-width="100px" class="dynamic">
                <span class="dynamic_text">{{$t('message.title05')}}</span>
                <el-form-item
                  v-for="(domain, index) in dynamicValidateForm_5.domains"
                  :label="'Ft' + (index+1)"
                  :key="domain.key"
                  :prop="'domains.' + index + '.value'"
                  :rules="[{
                    required: true, message: '此项不能为空', trigger: 'blur'
                  }]">
                  <el-input oninput="value=value.replace(/[^\d.]/g,'')" v-model="domain.value" auto-complete="off"></el-input>
                </el-form-item>
              </el-form>
            </el-col>
            <el-col :span="8">
              <el-form :model="form_1" ref="form_1" :rules="rules_1" label-width="100px" class="dynamic">
                <span class="dynamic_text">{{$t('message.title06')}}</span>
                <el-form-item prop="Lr" label="Lr">
                  <el-input oninput="value=value.replace(/[^\d.]/g,'')" v-model="form_1.Lr" auto-complete="off"></el-input>
                </el-form-item>
              </el-form>
            </el-col>
            <el-col :span="8">
              <el-form :model="form_2" ref="form_2" :rules="rules_2" label-width="100px" class="dynamic">
                <span class="dynamic_text">{{$t('message.title07')}}</span>
                <el-form-item prop="Lt" label="Lt">
                  <el-input oninput="value=value.replace(/[^\d.]/g,'')" v-model="form_2.Lt" auto-complete="off"></el-input>
                </el-form-item>
              </el-form>
            </el-col>
          </el-col>
        </el-col>
        <el-col :span="24">
          <h3>{{$t('message.info04')}}</h3>
          <div class="slider_box" style="margin-left:100px;">
            <el-form ref="form_KA" :model="form_KA" style="margin-bottom:20px;">
              <el-radio-group v-model="form_KA.resource">
                <el-radio label="1.0" border>1.0</el-radio>
                <el-radio label="1.1" border>1.1</el-radio>
                <el-radio label="1.3" border>1.3</el-radio>
                <el-radio label="1.5" border>1.5</el-radio>
                <el-radio label="1.8" border>1.8</el-radio>
              </el-radio-group>
            </el-form>
            <el-table :data="tableData" border style="width:67%;">
              <el-table-column prop="ka" label="KA" align='center'></el-table-column>
              <el-table-column prop="peiriod" :label=CycleNumberHour align='center'></el-table-column>
            </el-table>
          </div>
        </el-col>
        <!-- <el-col :span="24">
          <h3>{{$t('message.info05')}}</h3>
          <el-carousel :interval="4000" type="card" height="300px">
            <el-carousel-item v-for="item in 6" :key="item">
              <h3>{{ item }}</h3>
            </el-carousel-item>
          </el-carousel>
        </el-col> -->
        <el-col :span="24" style="padding-bottom:50px;padding-top:50px;">
          <div style="width:30%;margin:0 auto;">
            <span class="button" @click="returnPrePage">{{$t('message.Return')}}</span>
            <span class="button" @click="toNextPage">{{$t('message.Next')}}</span>
          </div>
        </el-col>
      </el-row>
    </div>
    <!-- 右侧悬浮框 -->
    <div class="rightPicBox">
      <img :src=rightPicUrl alt="">
    </div>
  </div>
</template>
<script>
  import {
    getreductionratiolist,
    getloadcondition
  }from '@/store/electric_load'
  import {
    getPicUrl
  }from '@/store/electric_motor'
  export default {
    name: 'SelectedLoad',
    data() {
      return {
        rightPicUrl:'',
        tabPosition: 'left',
        form: {

        },
        value:0,
        reducerName:'',
        options:[],
        selectedOptions:[],
        optionProps: {
          value: 'reduction_ratio',
          label: 'label',
        },
        radio: '1',
        dynamicValidateForm: {
          domains: [{
            value: ''
          }]
        },
        dynamicValidateForm_2: {
          domains: [{
            value: ''
          }]
        },
        dynamicValidateForm_3: {
          domains: [{
            value: ''
          }]
        },
        dynamicValidateForm_4: {
          domains: [{
            value: ''
          }]
        },
        dynamicValidateForm_5: {
          domains: [{
            value: ''
          }]
        },
        form_1:{
          Lr:''
        },
        rules_1:{
          Lr:[
            {required: true, message:'此项不能为空'}
          ]
        },
        form_2:{
          Lt:''
        },
        rules_2:{
          Lt:[
            {required: true, message:'此项不能为空'}
          ]
        },
        sliderChangeValue:'',
        selectLoadParam:{},
        form_KA:{
          resource:''
        },
        selectedSeries: this.$t('message.selectedSeries'),
        loadCondition: this.$t('message.loadCondition'),
        reducerSize: this.$t('message.reducerSize'),
        selectMotor: this.$t('message.selectMotor'),
        complete: this.$t('message.complete'),
        CycleNumberHour: this.$t('message.CycleNumberHour'),
        picUrl:'',
        tableData: [{
          ka: '1.0',
          peiriod: '0-1000',
        },{
          ka: '1.1',
          peiriod: '1000-1500',
        },{
          ka: '1.3',
          peiriod: '1500-2000',
        },{
          ka: '1.5',
          peiriod: '2000-3000',
        },{
          ka: '1.8',
          peiriod: '3000-5000',
        }]
      };
    },
    props:{
      param_1:Object,
      required:true
    },
    mounted(){
      this.sliderChange(4)
      this.form_1.Lr = '0'
      this.form_2.Lt = '0'
      var lang = localStorage.getItem('lang')
      if(lang == 'en'){
        this.rightPicUrl = '../../../static/load_en.png';
      }else{
        this.rightPicUrl = '../../../static/load_cn.png';
      }
    },
    methods: {
      toNextPage:function(){
        // 配置参数 构造数据
        if(!this.selectLoadParam.N){
          this.selectLoadParam.N = 4
        }
        this.selectLoadParam.fw = this.form_KA.resource
        this.selectLoadParam.Lr = this.form_1.Lr
        this.selectLoadParam.Lt = this.form_2.Lt

        const domains = this.dynamicValidateForm.domains
        const domains_2 = this.dynamicValidateForm_2.domains
        const domains_3 = this.dynamicValidateForm_3.domains
        const domains_4 = this.dynamicValidateForm_4.domains
        const domains_5 = this.dynamicValidateForm_5.domains
        const array_1 = []
        const array_2 = []
        const array_3 = []
        const array_4 = []
        const array_5 = []
        for(var i=0;i < domains.length;i++){
          array_1.push(
            domains[i].value
          )
          array_2.push(
            domains_2[i].value
          )
          array_3.push(
            domains_3[i].value
          )
          array_4.push(
            domains_4[i].value
          )
          array_5.push(
            domains_5[i].value
          )
        }
        var string_1 = array_1.join(",")
        var string_2 = array_2.join(",")
        var string_3 = array_3.join(",")
        var string_4 = array_4.join(",")
        var string_5 = array_5.join(",")
        this.selectLoadParam.T = string_1;
        this.selectLoadParam.n = string_2;
        this.selectLoadParam.t = string_3;
        this.selectLoadParam.Fr = string_4;
        this.selectLoadParam.Ft = string_5;
        sessionStorage.setItem('i',this.selectLoadParam.i);

        getloadcondition(this.selectLoadParam).then((response)=>{
          if(response.success === true){
            const data = response.data
            this.$emit("listenParam_2",data);
            this.$emit("listenPageChange","to_SizePage");
          }else{
            this.$message({
              message: '字段填写有误!',
              type: 'warning'
            });
            return false;
          }
        })
      },
      returnPrePage:function(){
        this.$emit("listenPageChange","to_SeriesPage");
      },
      //获取该减速机的减速比列表
      _getreductionratiolist:function(){
        getreductionratiolist(this.param_1).then((response)=>{
          this.reducerName = this.param_1.reducer_series_name;
          getPicUrl(this.param_1.reducer_series_name).then((response) => {
            if (response.success === true) {
              this.picUrl = response.data[0].outlook_picture
            }
          })
          this.selectLoadParam.reducer_series_name = this.param_1.reducer_series_name;
          if(response.success === true){
            this.options = [];
            this.options = response.data;
          }
        })
      },
      handleChange(val) {
        this.selectLoadParam.i = val[0];
      },
      sliderChange(val) {
        this.selectLoadParam.N = val;
        for(var i=0;i < 18;i++){
          this.dynamicValidateForm.domains.splice(i, 18);
          this.dynamicValidateForm_2.domains.splice(i, 18);
          this.dynamicValidateForm_3.domains.splice(i, 18);
          this.dynamicValidateForm_4.domains.splice(i, 18);
          this.dynamicValidateForm_5.domains.splice(i, 18);
        }
        const step = val;
        for(var i=0;i < step;i++){
          this.dynamicValidateForm.domains.push({
            value: '0',
            key: Date.now()
          });
          this.dynamicValidateForm_2.domains.push({
            value: '0',
            key: Date.now()
          });
          this.dynamicValidateForm_3.domains.push({
            value: '0',
            key: Date.now()
          });
          this.dynamicValidateForm_4.domains.push({
            value: '0',
            key: Date.now()
          });
          this.dynamicValidateForm_5.domains.push({
            value: '0',
            key: Date.now()
          });
        }
        this.sliderChangeValue = val;
      }
    }
  };
</script>
<style scoped>
  .rightPicBox {
    width:250px;
    height:1000px;
    position: absolute;
    right: 80px;
    top: 450px;
    border-radius: 15px;
    box-shadow: 0 0 15px rgb(224, 224, 224);
  }
  .content {
    width:100%;
    height: 100%;
    background: white;
    border-radius: 5px;
    box-shadow: 0 0 15px rgb(224, 224, 224);
    position: relative;
  }
  @media screen and (-webkit-min-device-pixel-ratio:0){
    .content {
      width:100%;
      height: 100%;
      background: white;
      border-radius: 5px;
      box-shadow: 0 0 15px rgb(224, 224, 224);
      position: relative;
    }
  }
  .top {
    height:100px;
    border-bottom:1px solid #EBEBEB;
  }
  .elec_speed {
    width:80%;
    margin:0 auto;
    padding-top:25px;
  }
  .el-steps {
    border-radius: 10px;
    background-color: #F5F7FA;
    background:url('../../../static/step.png') no-repeat #F5F7FA;
    background-size:20% 100%;
    background-position-x:28%;
  }
  .elec_select_left img{
    width: 15%;
    height: 15%;
    display: block;
    margin: 0 auto;
    padding-top: 50px;
  }
  .elec_select_left .text{
    text-align: center;
    font-weight: bold;
    font-size: 20px;
  }
  .el-cascader-menus el-popper{
    z-index: 2010;
    position: absolute;
    top: 284px;
    left: 952px;
  }
  .select_box {
    padding-left:10px;
    padding-top:130px;
  }
  .toNextPage {
    width:97px;
    height:42px;
    border-radius: 5px;
    background: #142479;
    text-align: center;
    line-height: 42px;
    color:white;
    margin-top:40px;
  }
  .elec_detail {
    width:80%;
    margin-top:70px;
    margin-left:40px;
  }
  .elec_detail h3 {
    padding-left:50px;
  }
  .slider_box {
    width:70%;
    margin:0 auto;
    padding-top:20px;
    padding-bottom:20px;
  }
  .cascader_box {
    width:85%;
    margin:0 auto;
    padding-top:20px;
    padding-bottom:20px;
    padding-left:30px;
  }
  .form_box {
    width:90%;
    margin:0 auto;
  }
  .form_box_title {
    width:90%;
    margin:0 auto;
  }
  .form_box .form_box_value .el-col , .form_box .form_box_title .el-col {
    padding-top:10px;
  }

  .el-carousel {
    width:80%;
    margin: 0 auto;
    margin-top:30px;
  }
  .el-carousel__item h3 {
    color: #475669;
    font-size: 14px;
    opacity: 0.75;
    line-height: 200px;
    margin: 0;
  }

  .el-carousel__item:nth-child(2n) {
    background-color: #99a9bf;
  }

  .el-carousel__item:nth-child(2n+1) {
    background-color: #d3dce6;
  }
  .button {
    display: inline-block;
    width:97px;
    height:42px;
    border-radius: 10px;
    background:#142479;
    color:#C6C6C6;
    text-align: center;
    line-height: 42px;
    margin-left:15px;
    cursor: pointer;
  }
  /* .button:hover{
    background:#142479;
    color:white;
  } */
  .dynamic{
    width:90%;
  }
  .dynamic_text{
    padding-left:100px;
    line-height:50px;
  }
  .paramBox {
    width:90%;
  }
  /* 1366px下样式 */
  @media screen and (max-width: 1367px) {
    .rightPicBox {
      width:200px;
      height:1000px;
      position: absolute;
      right: 30px;
      top: 400px;
      border-radius: 15px;
      box-shadow: 0 0 15px rgb(224, 224, 224);
    }
    .elec_detail {
      width:80%;
      margin-top:70px;
      margin-left:20px;
    }
    .paramBox {
      width:93%;
    }
    .cascader_box {
      width:85%;
      margin:0 auto;
      padding-top:20px;
      padding-bottom:20px;
      padding-left:85px;
    }
    .content {
      width:100%;
      height: 100%;
      background: white;
      border-radius: 5px;
      box-shadow: 0 0 15px rgb(224, 224, 224);
      position: relative;
    }
    @media screen and (-webkit-min-device-pixel-ratio:0){
      .content {
        width:100%;
        height: 100%;
        background: white;
        border-radius: 5px;
        box-shadow: 0 0 15px rgb(224, 224, 224);
        position: relative;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/view/LoadSelection/SelectedLoad.vue